<template>

  <div>
    <div class="children-container">
      <div class="children-module-name">个人资料</div>
      <div style="display: flex;background-color: #FFFFFF;padding: 10px;width: 100%;flex-direction: column">

        <div style="display: flex;width: 100%">
          <div style="flex: 1;border-right: 1px solid #f5f5f5;">
            <div class="children-module-info">
              <a-form-model ref="userForm" :rules="userFormRules" :model="userForm" layout="vertical"
                            :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item label="姓名" prop="name">
                  <a-input style="width: 420px" placeholder="请输入姓名" v-model="userForm.name" :disabled="(userInfo.name == '' || userInfo.name == null) ? false : true"></a-input>
                  <span style="margin-left: 10px;font-size: 12px;color: #666666">*请填写你的真实姓名，提交后不可修改</span>
                </a-form-model-item>
<!--                <a-form-model-item label="昵称" prop="nickname">-->
<!--                  <a-input placeholder="请输入昵称" v-model="userForm.nickname"></a-input>-->
<!--                </a-form-model-item>-->
                <a-form-model-item label="性别" prop="sex">
                  <a-radio-group v-model="userForm.sex" :disabled="(userInfo.sex == null || userInfo.sex == '') ? false : true">
                    <a-radio value="MAN">男</a-radio>
                    <a-radio value="WOMAN">女</a-radio>
                  </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="出生年月" prop="birthday">
                  <a-date-picker format='YYYY-MM-DD' v-model="userForm.birthday" @change="changeBirthday" :disabled="(userInfo.birthday == null || userInfo.birthday == '') ? false : true"/>
                </a-form-model-item>
                <a-form-model-item label="研究领域" prop="research_areas">
                  <a-textarea placeholder="请输入研究领域" v-model="userForm.research_areas" :auto-size="{ minRows: 2, maxRows: 6 }"></a-textarea>
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 8, offset: 4 }">
                  <a-button type="primary" block @click="submitPersonData"><span>确定</span> </a-button>
                </a-form-model-item>
              </a-form-model>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';

  export default {
    data() {
      let validateMail = (rule, value, callback) => {
        if (!commonApi.EmailReg.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        }
        callback();
      };

      let validateMobile = (rule, value, callback) => {
        if (!commonApi.MobileReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      };
        
  
      return {

        // 个人资料
        userForm: {
          name: '',
          nickname: '',
          sex: '',
          birthday: '',
          research_areas: ''
        },
        userFormLogin: {
          login_pwd: '',
        },
        userFormLoginRules: {
          login_pwd: [{ required: true, message: '请输入登录密码', trigger: 'change' }],
        },
        userFormRules: {
          name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
          // nickname: [{ required: true, message: '请输入昵称', trigger: 'change' }],
          // sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
          // birthday: [{ required: true, message: '请选择出生年月', trigger: 'change' }]
        },
        userInfo: {}
      };
    },
    mounted() {
      this.getInfo();
    },
    methods: {

      // 获取信息
      async getInfo() {
        let res = await Api.GetInfo({});
        if (res && res["code"] == "0") {
          this.userForm = res.user;
          this.userInfo = Object.assign({}, res.user);
        } else {
          this.$message.error(res.message);
        }
      },
      changeBirthday(e,s) {
        this.userForm.birthday = s;
      },
      async submitPersonData() {
        let that = this;
        this.$refs.userForm.validate(async valid => {
          if (valid) {

            if (this.userInfo && !this.userInfo.name) {
              this.$confirm({
                title: '信息提示',
                content: h => <div>您的姓名、性别、出生年月一经提交不可修改，请确认是否提交。</div>,
                async onOk() {
                  let res = await Api.EditInfo(that.userForm);
                  if (res && res['code'] == '0') {
                    that.$message.success(res.message);
                    that.getInfo();
                  } else {
                    that.$message.error(res.message);
                  }
                },
                async onCancel() {
                  console.log('Cancel');
                },
                class: 'test',
              });
            } else {
              let res = await Api.EditInfo(that.userForm);
              if (res && res['code'] == '0') {
                that.$message.success(res.message);
                that.getInfo();
              } else {
                that.$message.error(res.message);
              }
            }

          }
        });
      }
    },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .code {
    background-color: #007F76;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
  .children-module-content {
    background-color: #fff;
  }
</style>